export default function Section4() {
    return (
        <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20">
            
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">

                {/* Left Side - Text */}
                <div className="md:w-1/2 text-center md:text-left mt-10">

                    <h2 className="text-[24px] md:text-[32px] font-bold text-[#1a1a1a] mb-6 leading-[32px] md:leading-[41px]">
                        SEO Services in New York That Drive Traffic, Leads, and Revenue
                    </h2>
                    <p className="text-gray-600 mb-8">
                        Increase your website traffic, attract qualified leads, and grow your revenue with  {" "}
                        <span className="font-semibold text-[#151515]">Mean3’s expert SEO services in New York.</span>{" "}
                        As a trusted NY SEO company , we combine technical expertise, tailored content strategies, and proven marketing approaches to help your business rank higher on search engines and reach the right audience.
                    </p>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-10">
                        {/* <a
                            href="https://mean3.com/contact-mean3/"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                        >
                            Get Your Free SEO Audit
                        </a> */}
                        
                    </div>
                </div>

                {/* Right Side - Hero Image */}
                <div className="md:w-1/2 flex justify-center">
                    <img
                        src="/assets/seo-hero.png" // Replace with your hero image path
                        alt="SEO Hero Illustration"
                        className="w-[90%] md:w-[100%] h-auto rounded-lg shadow-lg"
                    />
                </div>
            </div>

            {/* Problem Statement + Issues List */}
            <div className="max-w-6xl mx-auto mt-20 flex flex-col md:flex-row-reverse items-center gap-12">
                {/* Right Side - Existing SEO image */}
                <div className="md:w-1/2">
                    <img
                        src="/assets/SEO.jpg"
                        alt="SEO Problem Illustration"
                        className="w-full h-auto rounded-lg shadow-lg"
                    />
                </div>

                {/* Left Side - Content */}
                <div className="md:w-1/2 text-center md:text-left">
                    <h3 className="text-2xl font-bold text-[#151515] mb-6">
                         Partner with a Leading New York SEO Firm 
                    </h3>
                    <p className="text-gray-600 mb-8">
                         In the competitive New York market, having a website alone isn’t enough—your business needs visibility to the right audience. Many NY SEO companies miss out on valuable traffic because their strategies are outdated or unfocused. At Mean3, we combine technical SEO, tailored content, and performance analytics to ensure your website not only ranks but converts visitors into loyal customers.
                    </p>
                    <p className="text-gray-600 mb-8">
                         Our approach focuses on measurable growth. By improving organic search visibility, enhancing user experience, and optimizing for local and ecommerce searches, we connect your business with the customers who matter most. Partnering with Mean3 transforms your online presence into a powerful engine for revenue, credibility, and long-term digital authority in New York’s competitive landscape.
                    </p>

                    {/* Issues List */}
                    <ul className="space-y-5 mb-8">
                        
                        
                        
                        
                        
                        <li className="flex items-start gap-4">
                           
                            <p className="text-gray-800 font-medium">Ready to boost your New York business? Let’s craft your winning SEO strategy today</p>
                        </li>
                        <a
                            href="https://mean3.com/contact-mean3/"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                        >
                            Schedule a Strategy Call
                        </a>
                    </ul>

                    
                    
                </div>
            </div>
        </section>
    );
}
